<div
  class="mini-square"
  [ngClass]="{
    'link-square': link != null
  }"
  (click)="goToLink()"
>
  <h4 class="title text-hard-blue">{{ title }}</h4>
  <h1 class="title text-hard-blue">{{ value }}</h1>
  <h5 class="title text-hard-blue">{{ variation }}</h5>
</div>
